import React, { useState, useEffect } from "react";
import Header from "../Components/Header";
import Modal from "@material-ui/core/Modal";
import "./CSS/DescriptionPage.css";
import { useParams } from "react-router-dom";
import { store } from "../Redux/store";
import moment from "moment";
import { FiPaperclip } from "react-icons/fi";
import {
  web3_,
  _InfinityFactoryContractGetDataByAddress,
  _PayoutContract,
  _getSellTrack,
  _IDOSaleUserClaim,
  _getUserClaim,
  _ClaimCounter,
  _IDOSaleTotalCollectedFunds,
  _sellForAll,
  _GetMaxBuy,
  _getCheckWhiteListed,
  _is_sellStatus,
} from "../Services/Web3Connection";
import {
  connectToWallet,
  getAccountBalance,
  getAllAccountDetails,
} from "../Services/Index";
import Swal from "sweetalert2";
import {
  _IDOLaunchPadParticipate,
  _IDOSaleContractData,
} from "../Services/Web3Connection";
import { PayoutTokenContractAddress } from "../config/constants/Contracts";
import Footer from "../Components/Footer";
import Loading from "../Components/Animation/Loading/Loading";
// import Header from "../Header";

const DescriptionPage = (props) => {
  const [RaisedAmmount, setRaisedAmmount] = useState(0);
  const [sellStatus, setSellStatus] = useState(false);
  const [IDOStart, setIDOStart] = useState();
  const [validAmt, setValidAmt] = useState(false);
  const [whitelistData, setWhitelistData] = useState(false);
  const [ContractData, setContractData] = useState([]);
  const [investedAmt, setInvestedAmt] = useState(0);
  const [claimedAmt, setClaimAmt] = useState(0);
  const [isClaimCounter, setClaimCounter] = useState(0);
  const [isClaimStart, setClaimStart] = useState(0);
  const [isClaimEnd, setClaimEnd] = useState(0);
  const [isClaimButton, setClaimButton] = useState(false);
  const [remainClaimedAmt, setremainClaimedAmt] = useState(0);
  const [inputDisable, setInputDisable] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [isApproveDisabled, setisApproveDisabled] = useState(true);
  const [isStackDisabled, setisStackDisabled] = React.useState(true);
  const [isInputDisabled, setisInputDisabled] = React.useState(false);
  const [isValue, setValue] = React.useState(0);
  const [error, setError] = React.useState("");
  const [IDOSaleContract, setIDOSaleContract] = useState([]);
  const [isTransition, setTransition] = useState(false);
  const [isPayoutToken, setPayoutToken] = useState([]);
  const [approve, setapprove] = useState(false);
  const [getWhiteListMax, setWhitelistMax] = useState(0);
  const { status } = useParams();
  const [open, setOpen] = useState(false);
  const [TotalIdoFund, setTotalIdoFund] = useState(0);
  // const [CounterCrossCheck, setCounterCrossCheck] = useState(false);
  const [CounterStarted, setCounterStarted] = useState(null);
  const [ApproveHokeData, setApproveHokeData] = useState(0);
  const [ClaimThisRound, setClaimThisRound] = useState(0);

  useEffect(async () => {
    let data = await _InfinityFactoryContractGetDataByAddress(status);
    setContractData(data);
    setPayoutToken(await _PayoutContract());
    // let whiteData = await _getCheckWhiteListed(status);
    // setWhitelistData(whiteData);
    let dataFund = await _IDOSaleTotalCollectedFunds(data[2][1]);
    setRaisedAmmount(dataFund);
    let idoSale = await _IDOSaleContractData(status);
    setIDOSaleContract(idoSale.Contract);
    let sellData = await _sellForAll(status);
    setSellStatus(sellData);
    let IDOstart = await _is_sellStatus(status);
    console.log(IDOstart);
    setIDOStart(IDOstart);
    ClaimDetails(idoSale.Contract);
  }, []);

  useEffect(() => {
    DaysToGo();
  }, [isClaimStart, isClaimEnd]);

  function ClaimDetails(Contract) {
    Contract.methods
      .ClaimCounter()
      .call()
      .then((res) => {
        console.log(res, "calaim round");
        setClaimCounter(res);
      });
    Contract.methods
      .sTime_CR()
      .call()
      .then((res) => {
        // console.log(res, "claimm star");
        setClaimStart(res);
      });
    Contract.methods
      .eTime_CR()
      .call()
      .then((res) => {
        // console.log(res, "claimm end");
        setClaimEnd(res);
      });
    Contract.methods
      .TotalCollectedBNBFund()
      .call()
      .then((res) => {
        // console.log(res / Math.pow(10, 18), "total ido fund");
        setTotalIdoFund(res / Math.pow(10, 18));
      });
  }

  function DaysToGo() {
    if (isClaimCounter !== 0) {
      var countDownDate = 0;
      if (
        isClaimStart !== 0 &&
        parseInt(new Date().getTime()) < isClaimStart * 1000
      ) {
        countDownDate = isClaimStart;
        setClaimButton(true);
        document.getElementById("counter_name").innerHTML = "Starts In:";
      } else if (
        isClaimEnd !== 0 &&
        parseInt(new Date().getTime()) >= isClaimStart * 1000 &&
        parseInt(new Date().getTime()) < isClaimEnd * 1000
      ) {
        setClaimButton(false);
        document.getElementById("counter_name").innerHTML = "Ends In:";
        countDownDate = isClaimEnd;
      }
      // Update the count down every 1 second
      var x = setInterval(function () {
        // Get today's date and time
        var now = new Date().getTime();
        // Find the distance between now and the count down date
        var distance =
          new Date(countDownDate * 1000).getTime() - new Date(now).getTime();
        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        // Output the result in an element with id="demo"
        // document.getElementById("counter").innerHTML =
        //   days + "d " + hours + "h " + minutes + "m " + seconds + "s ";
        setCounterStarted(
          days + "d " + hours + "h " + minutes + "m " + seconds + "s "
        );
        // If the count down is over, write some text
        if (distance < 0) {
          clearInterval(x);
          // document.getElementById("start_in").innerHTML = `STARTED`;
          // document.getElementById("end_in").innerHTML = `ENDED`;
          document.getElementById(
            "counter"
          ).innerHTML = `Claiming isn't started yet`;
          setClaimButton(true);
        }
      }, 1000);
    }
  }

  const handleClose = () => {
    setOpen(false);
    setTotalAmount(0);
    setisApproveDisabled(true);
    setInputDisable(false);
    setTransition(false);
    setValidAmt(false);
    setapprove(false);
    setTotalAmount(0);
    setisStackDisabled(true);
  };

  const handleClaim = async () => {
    if (props.Connect) {
      if (
        isClaimStart <= parseInt(new Date().getTime() / 1000) &&
        parseInt(new Date().getTime() / 1000) <= isClaimEnd
      ) {
        // await _IDOSaleUserClaim(status);
        if (ClaimThisRound !== 0 && remainClaimedAmt !== 0) {
          await _IDOSaleUserClaim(status)
            .on("transactionHash", function (transactionHash) {
              console.log(transactionHash);
            })
            .on("confirmation", () => {})
            .then(() => Swal.fire("Claim Successful", "", "success"))
            .catch((err) => Swal.fire("Transaction Failed", "", "error"));
        } else {
          Swal.fire("Nothing to claim", "", "warning");
        }
        // ClaimThisRound !== 0
        //   ? await _IDOSaleUserClaim(status)
        //   : Swal.fire("Already claimed", "", "warning");
        // if()
        // remainClaimedAmt !== 0
        //   ? await _IDOSaleUserClaim(status)
        //   : Swal.fire("No amount to claim", "", "error");
      } else {
        Swal.fire("Claim round not started", "", "error");
      }
    } else {
      Swal.fire("Please Conncet Wallet", "", "error");
    }
  };

  if (props.Connect) {
    getTheInvestedAmt();
    getUserClaim();
    _getCheckWhiteListed(status).then((data) => setWhitelistData(data));
    _GetMaxBuy(status).then((data) => setWhitelistMax(data / Math.pow(10, 18)));
  }

  async function Participate(data) {
    setTransition(true);
    await _IDOLaunchPadParticipate(
      status,
      store.getState().ConnectivityReducer.metamaskAddress,
      web3_.utils.toWei(data.toString(), "ether")
    )
      .on("confirmation", () => {})
      // get New Contract Address
      .then((newContractInstance) => {
        setTransition(false);
        setValidAmt(false);
        setapprove(false);
        setTotalAmount("");
        Swal.fire("Transaction Successful", "", "success");
      })
      .catch((err) => {
        setTransition(true);
        Swal.fire("Transaction Failed 1", "", "error");
      });
  }

  const handleAmountChange = (e) => {
    console.log(ContractData[1][6] / Math.pow(10, 18));
    if (e.target.value <= ContractData[1][6] / Math.pow(10, 18)) {
      setTotalAmount(e.target.value);
    } else {
      setValidAmt(true);
      console.log("in Else");
    }
  };

  const handleOpen = () => {
    setOpen(true);
  };

  async function getTheInvestedAmt() {
    _getSellTrack(status).then((res) => setInvestedAmt(res));
  }

  function InvestmentKbutton() {
    // console.log(isClaimStart, isClaimEnd);
    const startDate = ContractData[1][3] / Math.pow(10, 18);
    const endDate = ContractData[1][4] / Math.pow(10, 18);
    const currentDate = parseInt(new Date().getTime() / 1000);
    const harcap = Math.ceil(ContractData[1][2] / Math.pow(10, 18));
    const InvestedAmt = Math.ceil(investedAmt / Math.pow(10, 18));
    if (startDate <= currentDate && currentDate < endDate) {
      return true;
    }
    return false;
  }

  async function getUserClaim() {
    await _getUserClaim(status).then((data) => {
      setClaimAmt(data[2] / Math.pow(10, 18));
      setremainClaimedAmt(data[3] / Math.pow(10, 18));
      setClaimThisRound(data[5] / Math.pow(10, 18));
    });
    setClaimButton(false);
  }
  // async function claimCounter() {
  //   await _claimCounter(status).then((data) => {
  //     setClaimCounter(data / Math.pow(10, 18));
  //   });
  // }

  async function handleClick() {
    getAllAccountDetails().then((res) => {
      if (res.result !== "") {
        props.setConnect(true);
        localStorage.setItem(
          "InfinityStatus",
          JSON.stringify({ status: true })
        );
      }
    });
    // await getAllAccountDetails().then(() => props.setConnect(true));
    connectTheWallet();
  }
  function connectTheWallet() {
    if (props.Connect) {
      // Investe by Default ON
      console.log(IDOStart);
      if (IDOStart == 0) {
        handleOpen();
      } else {
        Swal.fire("Investment is Unavailable", "", "warning");
      }
    }
  }
  // console.log(sellStatus, "sellStatus");

  async function _HandleChanged(e) {
    //new
    if (sellStatus) {
      console.log("sale for alll");
      if (
        ContractData[1][5] / Math.pow(10, 18) <= e.target.value &&
        e.target.value <= ContractData[1][6] / Math.pow(10, 18)
      ) {
        // console.log("ye kyon chlra");
        if (
          e.target.value <=
          ContractData[1][6] / Math.pow(10, 18) - investedAmt / Math.pow(10, 18)
        ) {
          setisApproveDisabled(false);
          setTotalAmount(e.target.value);
          setError("");
        } else {
          setError("Enter amount within your buy limit");
          // setTotalAmount(e.target.value);
          setisApproveDisabled(true);
          if (e.target.value < ContractData[1][5]) {
            setError("Enter amount within your buy limit");
            setisApproveDisabled(true);
          }
        }
      } else {
        // console.log("yee bahar h");
        setError("Enter amount within your buy limit");
        setisApproveDisabled(true);
      }
    } else {
      console.log("sale White Liste user ");

      if (whitelistData) {
        if (
          ContractData[1][5] / Math.pow(10, 18) <= e.target.value &&
          e.target.value <= getWhiteListMax
          // - investedAmt / Math.pow(10, 18)
        ) {
          if (
            e.target.value <=
            getWhiteListMax - investedAmt / Math.pow(10, 18)
          ) {
            setisApproveDisabled(false);
            setTotalAmount(e.target.value);
            setError("");
          } else {
            setError("Enter amount within your buy limit");
            setisApproveDisabled(true);
            if (e.target.value < ContractData[1][5]) {
              setError("Enter amount within your buy limit");
              setisApproveDisabled(true);
            }
          }
        } else {
          setError("Enter amount within your buy limit");
          setisApproveDisabled(true);
          // if (e.target.value < ContractData[1][5]) {
          //   setError("Enter amount within your buy limit");
          //   setTotalAmount(e.target.value);
          //   setisApproveDisabled(true);
          // }
          // if (
          //   getWhiteListMax - investedAmt / Math.pow(10, 18) <
          //   e.target.value
          // ) {
          //   setError("Your buy limit exhausted");
          //   setTotalAmount(e.target.value);
          //   setisApproveDisabled(true);
          // }
        }
      } else {
        Swal.fire("Not a white list user", "", "warning").then(() =>
          setOpen(false)
        );
      }
    }
  }

  async function isApprove() {
    setTransition(true);

    await isPayoutToken.methods
      .approve(status, web3_.utils.toWei(totalAmount.toString(), "ether"))
      .send({ from: store.getState().ConnectivityReducer.metamaskAddress })
      .on("transactionHash", function (transactionHash) {
        console.log(transactionHash);
      })
      .on("confirmation", () => {})
      // get New Contract Address
      .then((res) => {
        setTransition(false);
        setInputDisable(true);
        Swal.fire("Transaction Successful", "", "success");
        setApproveHokeData(totalAmount);
        setisApproveDisabled(true);
        setisStackDisabled(false);
      })
      .catch((err) => {
        setTransition(false);
        Swal.fire("Transaction Failed", "", "error");
        setisApproveDisabled(true);
        setisStackDisabled(true);
      });
  }

  async function isStacked() {
    console.log(
      store.getState().ConnectivityReducer.metamaskAddress,
      totalAmount
    );

    await IDOSaleContract.methods
      .SaleIDOToken(web3_.utils.toWei(totalAmount.toString(), "ether"))
      .send({ from: store.getState().ConnectivityReducer.metamaskAddress })
      .on("transactionHash", function (transactionHash) {
        console.log(transactionHash);
      })
      .on("confirmation", () => {})
      // get New Contract Address

      .then(() => {
        Swal.fire("Transaction Successful", "", "success");
        setInputDisable(false);
        setisStackDisabled(true);
        handleClose();
        setTotalAmount(0);
      })
      .catch((err) => {
        Swal.fire("Transaction Failed", "", "error");
        setisApproveDisabled(true);
        setisStackDisabled(false);
      });
  }

  return (
    <>
      <img
        className="infinitypageimg"
        src={process.env.PUBLIC_URL + "/assets/images/spacenubela.jpg"}
        alt="..."
      />
      {ContractData.length === 0 || isTransition ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100vh",
            justifyContent: "center",
          }}
        >
          <h3
            style={{
              color: "#ff832e",
              textAlign: "center",
              position: "relative",
            }}
          >
            Please Wait...
          </h3>
          <Loading />
        </div>
      ) : (
        <div className="bgimg">
          <Header Connect={props.Connect} setConnect={props.setConnect} />
          <Modal
            //  onClose={handleClose}
            open={open}
            style={{
              border: "2px solid #000",
              backgroundColor: "black",
              boxShadow: "2px solid black",
              height: 400,
              width: 500,
              margin: "auto",
              color: "white",
              zIndex: "100",
            }}
          >
            <div className="card">
              <div className="card-body">
                <div
                  className="d-flex"
                  style={{ justifyContent: "space-between", zIndex: "100" }}
                >
                  <div
                    className="inputtxts ml-3 mt-4"
                    style={{ fontFamily: "Industry-Bold, serif" }}
                  >
                    Participate
                  </div>
                  <button
                    class="cry-modal-new__x"
                    onClick={handleClose}
                    style={{ outine: "none" }}
                  >
                    <img
                      alt="logo"
                      src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE4LjM2NCA3LjA1MDQ4TDE2Ljk0OTcgNS42MzYyN0wxMiAxMC41ODZMNy4wNTAyNSA1LjYzNjI3TDUuNjM2MDQgNy4wNTA0OEwxMC41ODU4IDEyLjAwMDJMNS42MzYwNCAxNi45NUw3LjA1MDI1IDE4LjM2NDJMMTIgMTMuNDE0NEwxNi45NDk3IDE4LjM2NDJMMTguMzY0IDE2Ljk1TDEzLjQxNDIgMTIuMDAwMkwxOC4zNjQgNy4wNTA0OFoiIGZpbGw9IiNGRjI4NEMiLz4KPC9zdmc+Cg=="
                    />
                    {/* <div >
                        <AiOutlineClose />
                      </div> */}
                  </button>
                </div>
                <div className="container">
                  {/* <div className="modalalloc d-flex   mt-3" style={{justifyContent:'space-between'}}>
              <span className="ml-3 " style={{color:"gray",fontSize:"16px",fontWeight:'700'}}>Min/Max Allocation</span>
              <span className="  " style={{color:"#dd6f20",fontSize:"16px",fontWeight:'700'}}>300/10000 BUSD</span>
            </div> */}
                </div>
                <div className="container">
                  <div
                    className="d-flex  mt-3"
                    style={{ justifyContent: "space-between" }}
                  >
                    <span
                      className="ml-3 "
                      style={{
                        color: "white",
                        fontSize: "15px",
                        fontWeight: "700",
                        fontFamily: "Industry-Bold, serif",
                      }}
                    >
                      Minimum Buy
                    </span>
                    <span
                      className=""
                      style={{
                        color: "#dd6f20",
                        fontSize: "15px",
                        fontWeight: "700",
                        fontFamily: "Industry-Bold, serif",
                      }}
                    >
                      {ContractData[1][5] / Math.pow(10, 18)} BUSD
                    </span>
                  </div>
                </div>
                <div className="container">
                  <div
                    className="d-flex  mt-3"
                    style={{ justifyContent: "space-between" }}
                  >
                    <span
                      className="ml-3 "
                      style={{
                        color: "white",
                        fontSize: "15px",
                        fontWeight: "700",
                        fontFamily: "Industry-Bold, serif",
                      }}
                    >
                      Your Left Buy Limit
                    </span>
                    <span
                      className=""
                      style={{
                        color: "#dd6f20",
                        fontSize: "15px",
                        fontWeight: "700",
                        fontFamily: "Industry-Bold, serif",
                      }}
                    >
                      {sellStatus
                        ? ContractData[1][6] / Math.pow(10, 18) -
                          investedAmt / Math.pow(10, 18)
                        : getWhiteListMax - investedAmt / Math.pow(10, 18)}{" "}
                      BUSD
                    </span>
                  </div>
                </div>

                <div className="container">
                  <div
                    className="modalall  mt-3"
                    style={{ justifyContent: "space-between" }}
                  >
                    <span
                      className="ml-3 "
                      style={{
                        color: "white",
                        fontSize: "16px",
                        fontWeight: "700",
                        fontFamily: "Industry-Bold, serif",
                      }}
                    >
                      Your Current Balance
                    </span>
                    <span
                      className=""
                      style={{
                        color: "#dd6f20",
                        fontSize: "16px",
                        fontWeight: "700",
                        fontFamily: "Industry-Bold, serif",
                      }}
                    >
                      {props.Connect
                        ? parseFloat(
                            store.getState().ConnectivityReducer.metamaskBalance
                          ).toFixed(4) + " BUSD"
                        : "0 BUSD"}
                    </span>
                  </div>
                </div>

                <div className="container">
                  <div className="col-md-12 mt-3">
                    <span
                      className="alloctext"
                      style={{
                        color: "white",
                        fontSize: "16px",
                        fontWeight: "700",
                        fontFamily: "Industry-Bold, serif",
                      }}
                    >
                      Buy Token
                    </span>
                  </div>
                </div>
                <div className="container">
                  <div
                    className="modalall mt-2"
                    style={{ justifyContent: "space-between" }}
                  >
                    <input
                      onChange={_HandleChanged}
                      type="number"
                      min="0"
                      step="0.00001"
                      style={{
                        color: "white",
                        width: "90%",
                        outline: "none",
                        backgroundColor: "#00000000",
                        padding: "0  10px",
                        border: "1px solid #dd6f20",
                      }}
                      // value={totalAmount}
                      disabled={isInputDisabled || inputDisable}
                    />

                    <span
                      className=" "
                      style={{
                        color: "#dd6f20",
                        fontSize: "16px",
                        fontWeight: "700",
                        fontFamily: "Industry-Bold, serif",
                      }}
                    >
                      &nbsp;&nbsp;BUSD
                    </span>
                  </div>
                  <span style={{ color: "#fe0101", fontSize: "0.8rem" }}>
                    {error}
                  </span>
                </div>
                <div
                  className="ml-5"
                  style={{
                    fontSize: "16px",
                    fontWeight: "700",
                    fontFamily: "Industry-Bold, serif",
                    color: "#dd6f20",
                    textTransform: "uppercase",
                  }}
                >
                  1 BUSD =
                  {" " +
                    ContractData[1][0] / Math.pow(10, 18) +
                    " " +
                    ContractData[0][1]}
                </div>
                <div className="container">
                  <div className="totalam mt-3">
                    {/* <span className="ml-3 modeldesc">Min/Max Allocation</span> */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                      }}
                    >
                      <span
                        className="ml-3 modeldescs "
                        // value={totalAmount}
                        style={{
                          fontSize: "16px",
                          fontWeight: "700",
                          fontFamily: "Industry-Bold, serif",
                        }}
                      >
                        Total Amount of Token
                      </span>
                      <div
                        style={{
                          outline: "none",
                          backgroundColor: "#00000000",
                          padding: "0  10px",
                          cursor: "pointer",
                        }}
                      ></div>
                    </div>
                    <span
                      className=" modeldescnumss d-flex  "
                      style={{
                        color: "orange",
                        fontSize: "16px",
                        fontWeight: "700",
                      }}
                    >
                      <div className="" style={{ color: "rgb(221, 111, 32)" }}>
                        {parseFloat(
                          (totalAmount * ContractData[1][0]) / Math.pow(10, 18)
                        ).toFixed(2) +
                          " " +
                          ContractData[0][1]}
                      </div>

                      {/* data[1][0]/Math.pow(10,18) */}
                    </span>
                  </div>
                  <div className="totalam mt-3">
                    {/* <span className="ml-3 modeldesc">Min/Max Allocation</span> */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                      }}
                    >
                      <span
                        className="ml-3 modeldescs "
                        // value={totalAmount}
                        style={{
                          fontSize: "16px",
                          fontWeight: "700",
                          fontFamily: "Industry-Bold, serif",
                        }}
                      >
                        Approved Amount
                      </span>
                      <div
                        style={{
                          outline: "none",
                          backgroundColor: "#00000000",
                          padding: "0  10px",
                          cursor: "pointer",
                        }}
                      ></div>
                    </div>
                    <span
                      className=" modeldescnumss d-flex  "
                      style={{
                        color: "orange",
                        fontSize: "16px",
                        fontWeight: "700",
                      }}
                    >
                      <div className="" style={{ color: "rgb(221, 111, 32)" }}>
                        {/* {!isApproveDisabled
                          ? ApproveHokeData + " " + "BUSD"
                          : "0 BUSD"} */}
                        {isApproveDisabled
                          ? totalAmount + " " + "BUSD"
                          : "0 BUSD"}
                      </div>
                    </span>
                  </div>
                </div>

                <div className="d-flex justify-content-center">
                  <button
                    onClick={isApprove}
                    disabled={isApproveDisabled}
                    type="button"
                    class="participatebtn mt-2 btn btn-warning"
                    //  onClick={approvebtn(totalAmount)}
                  >
                    Approve
                  </button>

                  <>
                    <button
                      onClick={isStacked}
                      disabled={isStackDisabled}
                      type="button"
                      class="participatebtn mt-2 btn btn-warning mx-2"
                    >
                      Participate
                      {}
                    </button>
                  </>
                </div>
              </div>
            </div>
          </Modal>

          {/*---------------- Active content---------- */}

          <div className="container">
            <div className="buttontxt d-flex ml-5 mt-5">
              {/* <button
                type="button"
                class="btn butttons text-white "
                style={{ zIndex: "100" }}
              >
                Active
              </button> */}
              {/* <img
                style={{ zIndex: "100" }}
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUBAMAAAB/pwA+AAAAGFBMVEUAAAD/xwD/xwD/xwD/zwD/yAD/xgD/xwAOl1etAAAAB3RSTlMAgN8gEM+gZtFyLwAAAHBJREFUCNddj7EJQCEMRCNmADsHsLCVTJDGDQRbV1BQ1//6gwhedTyS3AW2lIEjW49Tc5oD56wHNr+wQEeCMbeg/diWo0OmgmvSYYhJAxmwLWDurH0VO2BZGSiaycgaUEJY+o91vhFvsNS5JZ/q96EPRwgaUSdfEDoAAAAASUVORK5CYII="
                class="img-fluid ml-2 logoimgs"
                alt="Responsive image"
              ></img> */}
            </div>

            <div class="mt-2">
              <div
                class="d-flex detailsactive"
                style={{ justifyContent: "space-between" }}
              >
                <div className="d-flex flex-column" style={{ maxWidth: "60%" }}>
                  <div className="d-flex activelogo" style={{ zIndex: "100" }}>
                    <img
                      className="mmlogo"
                      src={ContractData[3][0]}
                      alt="..."
                      class="rounded-circle rounded-circles"
                    />

                    <h1 className=" texth mt-4 ml-3">{ContractData[0][0]}</h1>
                  </div>

                  <div className="d-flex flex-column" style={{ zIndex: "100" }}>
                    <h5 className="hrading">Short Description</h5>
                    <span
                      className="w-75 textdesc text-white"
                      // dangerouslySetInnerHTML={{ __html: ContractData[3][9] }}
                    >
                      {ContractData[3][9] === "" ? (
                        <div style={{ color: "white" }}>
                          ‘Alisia’, a massive magical planet in the{" "}
                          {ContractData[0][0]}
                          verse, is home to the majestic {ContractData[0][0]}mon
                          creatures. These creatures each possess their own
                          magical abilities known as ‘elements’. There are a
                          number of said elements including fire, water, wind,
                          metal, and nature. The potency of the{" "}
                          {ContractData[0][0]}mon is determined by their rarity
                          and their genes. Some of these genes include luck,
                          accuracy, attack, intelligence and many more. These
                          genes all add up to {ContractData[0][0]}mon that have
                          thirty different levels of strength within the Bronze,
                          Silver, and Gold stages.
                        </div>
                      ) : (
                        ContractData[3][9].substring(0, 500)
                      )}
                    </span>
                  </div>
                </div>

                <div
                  className="activedetails"
                  style={{ justifyContent: "space-between", zIndex: "100" }}
                >
                  <div
                    className=" underline d-flex"
                    style={{ justifyContent: "space-between" }}
                  >
                    <span
                      style={{
                        fontSize: "20px",
                        fontWeight: "700",
                        color: "#dd6f20",
                        fontFamily: "Industry-Medium,serif",
                      }}
                    >
                      Claim Start on
                    </span>
                    <span
                      id="start_on"
                      style={{
                        fontSize: "20px",
                        fontWeight: "700",
                        color: "#dd6f20",
                        fontFamily: "Industry-Medium,serif",
                      }}
                    >
                      {isClaimStart == 0
                        ? "Yet to Start"
                        : moment(isClaimStart * 1000).format("lll")}
                    </span>
                  </div>
                  <div
                    className="underline d-flex mt-3"
                    style={{ justifyContent: "space-between" }}
                  >
                    <span
                      className=" "
                      style={{
                        fontSize: "20px",
                        fontWeight: "700",
                        color: "#dd6f20",
                        fontFamily: "Industry-Medium,serif",
                      }}
                    >
                      Claim Ends on
                    </span>
                    <span
                      id="end_on"
                      style={{
                        fontSize: "20px",
                        fontWeight: "700",
                        color: "#dd6f20",
                        fontFamily: "Industry-Medium,serif",
                      }}
                    >
                      {isClaimEnd == 0
                        ? "Yet to Start"
                        : moment(isClaimEnd * 1000).format("lll")}
                    </span>
                  </div>

                  <div style={{ justifyContent: "space-between" }}>
                    {/* <span
                        className=" "
                        style={{
                          fontSize: "20px",
                          fontWeight: "700",
                          color: "#dd6f20",
                          fontFamily: "Industry-Medium,serif",
                        }}
                      >
                        Min/Max 
                      </span> */}
                    <span
                      className=""
                      style={{
                        fontSize: "20px",
                        fontWeight: "700",
                        color: "#dd6f20",
                        fontFamily: "Industry-Medium,serif",
                      }}
                    >
                      {/* {console.log(ContractData, "valueeeeeee")} */}
                      {/* {ContractData[1][0]/ Math.pow(10, 18)} BUSD */}
                    </span>
                  </div>

                  <div
                    className="underlines mt-3"
                    style={{ zIndex: "100", justifyContent: "space-between" }}
                  >
                    <span
                      className=" "
                      style={{
                        fontSize: "20px",
                        fontWeight: "700",
                        color: "#dd6f20",
                        fontFamily: "Industry-Medium,serif",
                      }}
                    >
                      SoftCap/HardCap
                    </span>
                    <span
                      className=""
                      style={{
                        fontSize: "20px",
                        fontWeight: "700",
                        color: "#dd6f20",
                        fontFamily: "Industry-Medium,serif",
                      }}
                    >
                      {parseFloat(
                        ContractData[1][1] / Math.pow(10, 18)
                      ).toFixed(2) +
                        "/" +
                        parseFloat(
                          ContractData[1][2] / Math.pow(10, 18)
                        ).toFixed(2) +
                        " " +
                        "BUSD"}
                    </span>
                  </div>
                  {/* <div className="d-flex mt-3" style={{zIndex:'100'}}>
                      <span
                        className="text-white"
                        style={{
                          fontSize: "20px",
                          fontWeight: "700",
                          fontFamily: "Industry-Medium,serif",
                        }}
                      >
                        {ContractData[1][1] / Math.pow(10, 18)}
                      </span>
                      <span
                        style={{
                          fontSize: "20px",
                          fontWeight: "700",
                          fontFamily: "Industry-Medium,serif",
                          color: "white",
                          opacity: "50%",
                        }}
                      >
                        /{ContractData[1][2] / Math.pow(10, 18)}
                      </span>
                    </div> */}
                  <div className="progress mt-3" style={{ height: "0.5rem" }}>
                    <div
                      className="progress-bar "
                      role="progressbar"
                      style={{
                        width: `${
                          (TotalIdoFund /
                            (ContractData[1][2] / Math.pow(10, 18))) *
                            100 >
                          100
                            ? 100
                            : (TotalIdoFund /
                                (ContractData[1][2] / Math.pow(10, 18))) *
                              100
                        }%`,
                      }}
                      aria-valuenow={25}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    />
                  </div>
                  <div>
                    <span
                      style={{
                        fontSize: "20px",
                        fontWeight: "700",
                        fontFamily: "Industry-Medium,serif",
                        color: "#01FE04",
                      }}
                    >
                      {/* 1 GOLD = 0.02BUSD */}
                    </span>
                  </div>
                  <div className="underline mt-4"></div>
                  <div className="mt-2 ">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "20px",
                        fontWeight: "700",
                        fontFamily: "Industry-Medium,serif",
                        color: "#dd6f20",
                      }}
                    >
                      Share %
                      <div style={{ color: "#dd6f20", fontSize: "20px" }}>
                        {/* {isClaimCounter} */}
                        {investedAmt != 0
                          ? parseFloat(
                              (investedAmt / Math.pow(10, 18) / TotalIdoFund) *
                                100
                            ).toFixed(2) +
                            " " +
                            "%"
                          : "00.00 %"}
                      </div>
                    </div>
                  </div>
                  <div className="underline mt-4"></div>
                  <div className="mt-2 ">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "20px",
                        fontWeight: "700",
                        fontFamily: "Industry-Medium,serif",
                        color: "#dd6f20",
                      }}
                    >
                      <span
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          fontSize: "20px",
                          fontWeight: "700",
                          fontFamily: "Industry-Medium,serif",
                          color: "#dd6f20",
                        }}
                      >
                        Amount Available to claim
                      </span>
                      <div
                        style={{
                          color: "#dd6f20",
                          fontSize: "20px",
                          textAlign: "center",
                          fontFamily: "Industry-Medium,serif",
                        }}
                      >
                        {/* {console.log(ClaimThisRound, "round ka claim")} */}
                        {ClaimThisRound !== 0
                          ? parseFloat(ClaimThisRound).toFixed(2) +
                            " " +
                            ContractData[0][1]
                          : "00.00" + " " + ContractData[0][1]}
                      </div>
                    </div>
                  </div>
                  <div className="underline mt-4"></div>
                  <div className="mt-2 ">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "20px",
                        fontWeight: "700",
                        fontFamily: "Industry-Medium,serif",
                        color: "#dd6f20",
                      }}
                    >
                      <span
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          fontSize: "20px",
                          fontWeight: "700",
                          fontFamily: "Industry-Medium,serif",
                          color: "#dd6f20",
                        }}
                      >
                        Claim Round Created
                      </span>
                      <div
                        style={{
                          color: "#dd6f20",
                          fontSize: "20px",
                          textAlign: "center",
                          fontFamily: "Industry-Medium,serif",
                        }}
                      >
                        {isClaimCounter == 0
                          ? "No round created"
                          : "Round -" + " " + isClaimCounter}
                      </div>
                    </div>
                  </div>
                  <div className="mt-2 ">
                    <div
                      // id="counter_name"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "20px",
                        fontWeight: "700",
                        fontFamily: "Industry-Medium,serif",
                        color: "#dd6f20",
                      }}
                    >
                      <span
                        id="counter_name"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          fontSize: "20px",
                          fontWeight: "700",
                          fontFamily: "Industry-Medium,serif",
                          color: "#dd6f20",
                        }}
                      >
                        Claim Round
                      </span>
                      <div
                        id="counter"
                        style={{
                          color: "#dd6f20",
                          fontSize: "20px",
                          textAlign: "center",
                          fontFamily: "Industry-Medium,serif",
                        }}
                      >
                        {isClaimCounter == 0 && CounterStarted === null
                          ? "Claiming Haven't started yet"
                          : CounterStarted}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/*--------------Links and buttons contents  */}

            <div className="headtext d-flex flex-column ">
              <span
                className="text-warning linkactive d-flex"
                style={{ justifyContent: "space-between", zIndex: "100" }}
              >
                <div
                  style={{
                    fontSize: "20px",
                    fontWeight: "700",
                    fontFamily: "Outfit, sans-seri",
                    color: "#dd6f20",
                  }}
                >
                  Links
                </div>
                <div className="activegroupbuttons">
                  <div className="gruobuttons mt-2">
                    {InvestmentKbutton() && isClaimCounter == 0 ? (
                      <button
                        style={{
                          fontSize: "20px",
                          fontWeight: "700",
                          fontFamily: "Outfit, sans-seri",
                          marginRight: "10px",
                        }}
                        type="button"
                        onClick={handleClick}
                        class="btn btn-warning bscccon btn-lg  mt-2> "
                      >
                        {props.Connect === true ? "Particpate" : "Connect"}
                      </button>
                    ) : null}

                    {ContractData[1][3] / Math.pow(10, 18) >
                    parseInt(new Date().getTime() / 1000)
                      ? null
                      : null}

                    {parseInt(new Date().getTime() / 1000) >=
                      ContractData[1][4] / Math.pow(10, 18) ||
                    isClaimCounter != 0 ? (
                      <button
                        style={{
                          fontSize: "20px",
                          fontWeight: "700",
                          fontFamily: "Outfit, sans-seri",
                        }}
                        type="button"
                        disabled={isClaimButton}
                        onClick={handleClaim}
                        class="btn btn-warning bscccon btn-lg  mt-2> "
                      >
                        Claim
                      </button>
                    ) : null}

                    <a
                      href={
                        "https://testnet.bscscan.com/address/" + `${status}`
                      }
                      target="_blank"
                      style={{
                        fontSize: "20px",
                        fontWeight: "700",
                        fontFamily: "Outfit, sans-seri",
                      }}
                      type="button"
                      class="btn btn-outline-warning bscccons btn-lg mx-2 mt-1 "
                    >
                      View Bscscan
                    </a>
                  </div>
                </div>
              </span>

              <div class="d-flex flex-column" style={{ zIndex: "100" }}>
                <div className="d-flex  socialmdialink">
                  <a href={ContractData[3][1]} target="_blank">
                    <img
                      style={{ padding: "6px" }}
                      src="https://samurai.cyberfi.tech/_nuxt/img/website.edbded8.svg"
                      alt="..."
                      class="rounded-circle border border-warning"
                    />
                  </a>
                  <a href={ContractData[3][3]} target="_blank">
                    <img
                      style={{ padding: "6px" }}
                      src="https://samurai.cyberfi.tech/_nuxt/img/twitter.19a9591.svg"
                      alt="..."
                      class="rounded-circle border border-warning ml-3"
                    />
                  </a>
                  <a href={ContractData[3][2]} target="_blank">
                    <img
                      style={{ padding: "6px" }}
                      src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyNSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIzLjAzMzQgMC4xMzYyMUwxLjE1MzM3IDguNTczNTRDLTAuMzM5ODU1IDkuMTczMyAtMC4zMzEyMTYgMTAuMDA2MyAwLjg3OTQwNSAxMC4zNzc3TDYuNDk2ODkgMTIuMTMwMUwxOS40OTQxIDMuOTI5NzRDMjAuMTA4NyAzLjU1NTgxIDIwLjY3MDIgMy43NTY5NyAyMC4yMDg2IDQuMTY2NjhMOS42NzgzMiAxMy42NzAySDkuNjc1ODVMOS42NzgzMiAxMy42NzE1TDkuMjkwODIgMTkuNDYxN0M5Ljg1ODQ5IDE5LjQ2MTcgMTAuMTA5IDE5LjIwMTMgMTAuNDI3NCAxOC44OTQxTDEzLjE1NTkgMTYuMjQwOEwxOC44MzE0IDIwLjQzMjlDMTkuODc3OSAyMS4wMDkzIDIwLjYyOTQgMjAuNzEzMSAyMC44ODk4IDE5LjQ2NDJMMjQuNjE1NSAxLjkwNTg2QzI0Ljk5NjggMC4zNzY4NTQgMjQuMDMxOCAtMC4zMTU0NTkgMjMuMDMzNCAwLjEzNjIxWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg=="
                      alt="..."
                      class="rounded-circle border border-warning ml-3"
                    />
                  </a>
                  <a href={ContractData[3][4]} target="_blank">
                    <img
                      style={{ padding: "6px" }}
                      src={
                        process.env.PUBLIC_URL + "/assets/images/whitepaper.png"
                      }
                      alt="..."
                      class="rounded-circle border border-warning ml-3"
                    />
                  </a>
                </div>
                <h1 style={{ margin: "30px -5px", marginBottom: "-20px" }}>
                  About
                </h1>
              </div>
            </div>

            {/*--------------Links and buttons contents  */}
            {/* ------------About---------- */}
            <div class="row">
              {ContractData[3][8] === "" ? (
                <div
                  className="col-md-12 col-xs-12 mt-5"
                  style={{ color: "white", marginBottom: "45px" }}
                >
                  About IDO data is not set by the Admin
                </div>
              ) : (
                <div
                  class="col-md-12 col-xs-12 mt-5"
                  style={{ color: "white", marginBottom: "45px" }}
                  dangerouslySetInnerHTML={{ __html: ContractData[3][8] }}
                ></div>
              )}
            </div>
            <>
              {/* <div class="row">
                <div
                  class="col-md-12 col-xs-12 mt-5"
                  style={{
                    color: "white",
                    marginBottom: "45px",
                    opacity: "100%",
                  }}
                  dangerouslySetInnerHTML={{ __html: ContractData[3][8] }}
                ></div>
              </div> */}
              {/* <div class="row">
                <div class="col-md-12 col-xs-12 mt-5">
                  <h1 className="hrading text-white">About Projects</h1>
                  <h5 className="textdescs text-white">
                    {ContractData[0][0]} is a IDO that combines fun and action
                    with incredible NFTs.
                  </h5>
                </div>
              </div>

              <div class="row">
                <div class="col-md-7 col-xs-12 mt-5">
                  <h5 className="textdescs text-white">
                    {ContractData[3][9] === "" ? (
                      <h5 style={{ color: "white" }}>
                        ‘Alisia’, a massive magical planet in the{" "}
                        {ContractData[0][0]}
                        verse, is home to the majestic {ContractData[0][0]}mon
                        creatures. These creatures each possess their own
                        magical abilities known as ‘elements’. There are a
                        number of said elements including fire, water, wind,
                        metal, and nature. The potency of the{" "}
                        {ContractData[0][0]}mon is determined by their rarity
                        and their genes. Some of these genes include luck,
                        accuracy, attack, intelligence and many more. These
                        genes all add up to {ContractData[0][0]}mon that have
                        thirty different levels of strength within the Bronze,
                        Silver, and Gold stages.
                      </h5>
                    ) : (
                      ContractData[3][9]
                    )}
                  </h5>
                </div>

                <div class="col-md-5 col-xs-12 mt-4">
                  <img
                    src="https://samurai.cyberfi.tech/_nuxt/img/1.468c228.png"
                    class="img-fluid ml-3"
                    alt="Responsive image"
                  ></img>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 col-xs-12 mt-4">
                  <img
                    src="https://samurai.cyberfi.tech/_nuxt/img/2.dff53aa.png"
                    class="img-fluid ml-3"
                    alt="Responsive image"
                  ></img>
                </div>

                <div class="col-md-6 col-xs-12 mt-5">
                  <h5 className="textdescs text-white">
                    {ContractData[3][9] === "" ? (
                      <h5 style={{ color: "white" }}>
                        One of the main objectives of {ContractData[0][0]} is to
                        collect as many
                        {ContractData[0][0]}mon as you can- a so-called
                        ‘Play-to-catch’ game. You can find standard{" "}
                        {ContractData[0][0]}mon in the {ContractData[0][0]}verse
                        on either Alisia or later on {ContractData[0][0]}land.
                        Players can also earn $BLUC by playing and stake the
                        $BLUC to yield the secondary token, $SCRL, which will be
                        used to summon new {ContractData[0][0]}mon at the
                        Summoning Altar.
                      </h5>
                    ) : (
                      ContractData[3][9]
                    )}
                  </h5>
                </div>
              </div> */}
            </>
            {/* -----------close About------------ */}

            {/*---------Description---------- */}
            <div className="headingtext col-lg-6 col-md-6 col-xs-12 d-flex">
              <img
                src={ContractData[3][0]}
                alt="..."
                class="rounded-circle roundlogo mt-2"
              ></img>
              <h3
                className="text-white ml-3 mt-2"
                style={{ fontFamily: "Outfit, sans-serif" }}
              >
                DETAILS
              </h3>
            </div>

            <div className="row">
              <div className="col-md-6 col-xs-12">
                <div
                  className="card  m-3 mb-5"
                  style={{
                    width: "100%",
                    fontFamily: "Outfit, sans-serif",
                  }}
                >
                  <span className="titlehead">USER INFORMATION</span>
                  <div className="card-body" id="userINFo">
                    <div class="form-group ">
                      <div class="underlines descs ">
                        <label htmlFor="name" class="opacitylabel">
                          User Add
                        </label>
                        <span
                          style={{ color: "white", fontSize: " 14px" }}
                          className="ml-5"
                        >
                          {store.getState().ConnectivityReducer.metamaskAddress}
                        </span>
                      </div>

                      <div class="underlines mt-3">
                        <label for="name" class="opacitylabel">
                          Invested Amount
                        </label>
                        <label for="name" class="descs ">
                          {investedAmt / Math.pow(10, 18) === ""
                            ? "0 BUSD"
                            : investedAmt / Math.pow(10, 18) + " " + "BUSD"}
                        </label>
                      </div>

                      <div class="underlines mt-3">
                        <label for="name" class="opacitylabel ">
                          Claimed Token Amount
                        </label>
                        <label for="name" class="descs ">
                          {claimedAmt === ""
                            ? "00.00" + " " + ContractData[0][1]
                            : parseFloat(claimedAmt).toFixed(2) +
                              " " +
                              ContractData[0][1]}
                        </label>
                      </div>
                      <div class="underlines mt-3">
                        <label for="name" class="opacitylabel">
                          Remaining Token Amount
                        </label>
                        <label for="name" class="descs  ">
                          {remainClaimedAmt === 0
                            ? "00.00" + " " + ContractData[0][1]
                            : parseFloat(remainClaimedAmt).toFixed(2) +
                              " " +
                              ContractData[0][1]}
                        </label>
                      </div>
                      {/* <div class="underlines mt-3">
                          <label for="name" class="opacitylabel">
                            PURCHASED
                          </label>
                          <label for="name" class="descs ">
                            Not Connected
                          </label>
                        </div> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-xs-12">
                <div className="card m-3  mb-5" style={{ width: "100%" }}>
                  <span className="titlehead">TOKEN INFORMATION</span>
                  <div className="card-body">
                    <div class="form-group ">
                      <div class="underlines">
                        <label for="name" class="opacitylabel">
                          Token Name
                        </label>
                        <label for="name" class="descs ml-5 ">
                          {ContractData[0][0]}
                        </label>
                      </div>

                      <div class="underlines mt-3">
                        <label for="name" class="opacitylabel">
                          Token Symbol
                        </label>
                        <label for="name" class="descs ml-5 ">
                          {ContractData[0][1]}
                        </label>
                      </div>

                      <div class="underlines mt-3">
                        <label for="name" class="opacitylabel">
                          IDO Add
                        </label>
                        <label for="name" class="descs ml-5 ">
                          {ContractData[2][1]}
                        </label>
                      </div>
                      <div class="underlines mt-3">
                        <label for="name" class="opacitylabel">
                          Target Achieved
                        </label>
                        <label for="name" class="descs ml-5 ">
                          {TotalIdoFund + " " + "BUSD"}
                        </label>
                      </div>
                      {/* <div class="underlines mt-3">
                          <label for="name" class="opacitylabel">
                            Total Supply
                          </label>
                          <label for="name" class="descs ml-5 ">
                          {ContractData[3][1]}
                          </label>
                        </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/*---------Close Description---------- */}
          </div>
          {/* -------------Close Active cintent------------ */}
        </div>
      )}
      {/* <Footer /> */}
    </>
  );
};

export default DescriptionPage;
